export default {
    add_patient: "Бейтапты кошуу",
    add_task: "Тапшырманы кошуу",
    calls: "Чалуулар",
    chat_panel: "Чаттардын панели",
    clinic_id: "Клиниканын Id",
    confirm: "ырастоо",
    expenses: "Чыгымдар",
    high: "Бийик",
    low: "Кыска",
    medium: "Орточо",
    no_notifications: "Билдирмелер жок",
    read_all: "Бардыгы окулду",
    remove_confirmation: "Ырастоону жокко чыгаруу",
    tasks: "Тапшырмалар"
}
